import React from 'react';

function Question({ question, onAnswer, selectedAnswer }) {
    const optionLabels = ['A', 'B', 'C', 'D', 'E', 'F'];

    return (
        <div className="w-full">
            {/* Question Text */}
            <h3 className="text-xl md:text-2xl font-bold text-study-black mb-6 leading-relaxed">
                {question.text || 'Question text missing'}
            </h3>

            {/* Options */}
            {question.options && question.options.length > 0 ? (
                <div className="space-y-3">
                    {question.options.map((option, index) => {
                        const isSelected = selectedAnswer === option;
                        return (
                            <button
                                key={index}
                                onClick={() => onAnswer(question._id, option)}
                                className={`w-full text-left p-4 rounded-xl border-2 transition-all ${
                                    isSelected
                                        ? 'border-study-teal bg-study-teal/10 shadow-md'
                                        : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
                                }`}
                            >
                                <div className="flex items-start gap-4">
                                    {/* Option Label */}
                                    <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm ${
                                        isSelected
                                            ? 'bg-study-teal text-study-black'
                                            : 'bg-gray-100 text-gray-600'
                                    }`}>
                                        {optionLabels[index] || index + 1}
                                    </span>
                                    {/* Option Text */}
                                    <span className={`flex-1 ${isSelected ? 'text-study-black font-medium' : 'text-gray-700'}`}>
                                        {option}
                                    </span>
                                    {/* Check Mark */}
                                    {isSelected && (
                                        <span className="flex-shrink-0 text-study-teal text-xl">
                                            ✓
                                        </span>
                                    )}
                                </div>
                            </button>
                        );
                    })}
                </div>
            ) : (
                <div className="text-center py-8">
                    <div className="text-4xl mb-2">⚠️</div>
                    <p className="text-gray-600">No options available for this question</p>
                </div>
            )}
        </div>
    );
}

export default Question;